import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-232b2803"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "custom-modal" }
const _hoisted_2 = { class: "modal-dialog mt-5" }
const _hoisted_3 = { class: "modal-content bg-transparent border-0" }
const _hoisted_4 = { class: "modal-header border-0 mt-5" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "modal-title w-100 text-white justify-content-center text-center",
  id: "loginModalLabel"
}, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-center mb-3" }, "Log-in to Continue Application"),
  /*#__PURE__*/_createElementVNode("h5", { class: "text-center mb-1 d-none" }, "Log in")
], -1))
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "login bg-white rounded-2 mx-5" }
const _hoisted_8 = { class: "card shadow-sm bg-transparent border-0" }
const _hoisted_9 = { class: "card-body px-4 bg-white rounded-2" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-none modal-footer" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-secondary",
    "data-bs-dismiss": "modal"
  }, " Close "),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-primary"
  }, "Understood")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          (_ctx.closeBtn)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn-close position-absolute top-0 end-0 bg-white mx-2 mt-4 rounded-circle text-primary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closeClick'))),
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_Form)
              ])
            ])
          ])
        ]),
        _hoisted_10
      ])
    ])
  ]))
}